var Curriculog = Curriculog || {};

Curriculog.DateToFilter = (function ($, _, Backbone, DateToFilter) {
	
	DateToFilter = Backbone.View.extend({

		el: function () {
			return $('#report-9-to');
		},

		events: {},

		initialize: function(options) {
			this.params = options.params;
		},

		get: function(date) {
			this.$el.val(date);
			this.$el.datepicker();
		},

		set: function() {
			return this.$el.val();
		}

	});

	return DateToFilter;

})($, _, Backbone, Curriculog.DateToFilter || {});